<script setup>
import {Bar} from 'vue-chartjs';
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from 'chart.js'
import {onBeforeMount, ref} from "vue";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const props = defineProps({
  chartLabels: Array,
  dataValues: Array,
  axisLabel: String
})

const chartData = ref({
  labels: props.chartLabels,
  datasets: [{
    data: props.dataValues,
    backgroundColor: 'rgba(0, 121, 107, 1)',
    hoverBackgroundColor: 'rgba(0, 121, 107, 0.8)',
    datalabels: {
      anchor: 'end',
      align: 'end',
    }
  }],
})
const chartOptions = ref({
  indexAxis: 'y',
  title: {
    display: false
  },
  scales: {
    y: {
      barPercentage: 0.6,
      gridLines: {
        display: false
      },
    },
    x: {
      scaleLabel: {
        display: props.axisLabel != null,
        labelString: props.axisLabel
      },
      ticks: {
        suggestedMax: 0,
        suggestedMin: 0,
        stepSize: 5
      }
    }
  },
  plugins: {
    legend: {
      display: false
    },
    tooltips: {
      enabled: false,
    },
  },
  responsive: true,
  maintainAspectRatio: false
})

const dataProcess = () => {
  chartOptions.value.scales.x.ticks.suggestedMax = props.dataValues.reduce(function (a, b) {
    return Math.max(a, b);
  }) + 4;

  let lowestValue = props.dataValues.reduce(function (a, b) {
    return Math.min(a, b)
  });

  if (lowestValue < 0) {
    chartOptions.value.scales.x.ticks.suggestedMin = lowestValue - 5;
  }

  // var colours = this.dataValues.map((value) => value < 0 ? 'red' : 'rgba(0, 121, 107, 1)');
  chartData.value.datasets[0].datalabels.anchor = props.dataValues.map((value) => value < 0 ? 'start' : 'end');
  chartData.value.datasets[0].datalabels.align = props.dataValues.map((value) => value < 0 ? 'start' : 'end');
}

onBeforeMount(() => {
  dataProcess();
})
</script>


<template>
  <Bar :data="chartData" :options="chartOptions"/>
</template>
